import { FC } from "react";
import Chip from "@mui/material/Chip";
import { mapStatus, getStatusColor } from "../utils/helpers";

interface StatusBadgeProps {
  status: string;
  size?: "small" | "medium";
}

export const StatusBadge: FC<StatusBadgeProps> = ({
  status,
  size = "small",
}) => {
  const displayText = mapStatus(status);
  const color = getStatusColor(status);

  return (
    <Chip
      label={displayText}
      color={color}
      size={size}
      variant="filled"
      sx={{
        fontWeight: 500,
        minWidth: 80,
      }}
    />
  );
};
